module.exports = __webpack_public_path__ + "static/img/ravine.06b0a3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/drawing_painting/ravine.jpg
// module id = fFCJ
// module chunks = 1